<template>
  <div class="item">
    <div class="pic-box">
      <img class="rect1" src="../../../assets/img/rect.png">
      <img class="rect2" src="../../../assets/img/rect.png">
      <img class="frame" src="../../../assets/img/line.png">
      <div class="cir cir1"></div>
      <div class="cir cir2"></div>
      <div class="line"></div>
      <div class="line line2"></div>
    </div>
    <h1>区块链基础服务</h1>
    <div class="con">
      <span>P2P协议</span><span class="margin-l">共识算法</span><br>
      <span>智能合约</span><span class="margin-l">分布式账本</span>
    </div>
  </div>
</template>

<script>
  export default {
    name: "base-service"
  }
</script>

<style lang="less" scoped>
  @import "../../../assets/less/animate";

  .item {
    width: 25%;
    min-width: 290px;
    height: 100%;
    cursor: pointer;
    .pic-box {
      position: relative;
      margin: 82px auto 0;
      width: 172px;
      height: 130px;
      .rect1 {
        position: absolute;
        left: 3px;
        top: 0;
        z-index: 10;
      }
      .rect2 {
        position: absolute;
        right: 0;
        bottom: 10px;
        z-index: 10;
      }
      .frame {
        position: absolute;
        left: 40px;
        top: 20px;
        z-index: 0;
      }
      .line {
        position: absolute;
        width: 40px;
        height: 4px;
        background-color: #333333;
        left: 22px;
        top: 60px
      }
      .line2 {
        left: 110px;
        top: 126px;
      }
      .cir {
        box-sizing: border-box;
        position: absolute;
        width: 20px;
        height: 20px;
        left: 120px;
        top: 15px;
        border-radius: 50%;
        border: 5px solid #333333;
        background-color: white;
        z-index: 5;
      }
      .cir2 {
        left: 35px;
        top: 95px;
      }
    }
    h1 {
      margin: 40px 0 25px;
      font-size: 2rem;
      text-align: center;
    }
    .con {
      font-size: 1.75rem;
      color: #999999;
      text-align: center;
      .margin-l {
        margin-left: 10px;
      }
    }
    &:hover {
      box-shadow:0px 0px 40px rgba(111,111,111,0.04);
    }
    &:hover .cir1 {
      border-color: #0AD3FD;
      animation: p1-c1 3s linear infinite;
    }
    &:hover .cir2 {
      border-color: #0AD3FD;
      animation: p1-c2 3s linear infinite;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/part2/pics/BaseService.vue